import React, { Component } from 'react';
import {Input} from 'antd';
import API from '../../../../api/api';
import classnames from 'classnames';
import DocumentTitle from 'react-document-title';
import './landing.less';
class Landing extends Component {
    state = {
        accountData:'',
        isClick: false,
        pwdData: '',
    }

    componentWillMount() {
        
    }

    isClick(accountData, pwdData) {
        if (accountData != '' && pwdData != '') {
            return true
        }
        return false
    }

    accountChange = async (event) => {
        event.persist();
        let value = event.target.value;
        let b = await this.isClick(value, this.state.pwdData);
        this.setState({
            accountData: value,
        }, () => {
            if (b) {
                this.setState({ isClick: true })
            } else {
                this.setState({ isClick: false })
            }
        });
    };
    pwdChange = async (event) => {
        event.persist();
        let value = event.target.value;
        let b = await this.isClick(this.state.accountData, value);
        this.setState({ 
            pwdData: value 
        }, () => {
            if (b) {
                this.setState({ isClick: true })
            } else {
                this.setState({ isClick: false })
            }
        })
    }
    sure = async () => {
        const { isClick, accountData, pwdData} = this.state;
        if (!isClick) return;
        // 验证 
        let result = await API.playConsumeLogin({ companyName: accountData, password: pwdData });
        if (!result) return
        if (result.status == 1) {
            if(localStorage.getItem('companyList')){
                localStorage.removeItem('companyList')
            }
            localStorage.setItem('companyList',JSON.stringify(result.data.companyList));
            let companyCode=result.data.loginCompany.companyCode;
            let companyDesc=result.data.loginCompany.companyDesc;
            console.log(companyCode,companyDesc);
            this.props.history.push('/query/'+((companyCode[0]=='F'||companyCode[0]=='S')?'overview':'detail')+'?companyCode=' + companyCode+'&roleName=' + companyDesc);
            return
        }
        alert(result.msg);
    }
    render() {
        const {
            isClick,
        } = this.state;
        return (
            <DocumentTitle title="铛铛合作方核销查询系统">
                <div className="LandingMain">
                    <div className="model">
                        <h3>铛铛合作方</h3>
                        <h6>核销查询系统</h6>
                        <div className="account">
                            <span></span>
                            <span>登录帐户</span>
                            <span>
                            <Input className="circleId" placeholder="请输入登录帐户" onChange={this.accountChange.bind(this)} />
                            </span>
                        </div>
                        <div className="pwd">
                            <span></span>
                            <span>权限密码</span>
                            <span>
                                <Input className="circleId" placeholder="请输入权限密码" onChange={this.pwdChange.bind(this)} />
                            </span>
                        </div>
                        <div className="btn" className={classnames('btn', { btnDis: !isClick })} onClick={this.sure.bind(this)}>确定</div>
                    </div>
                </div>
            </DocumentTitle>
        )
    }
}
export default Landing;